import { atom } from "recoil";
import { IEmailIRoute, IEmailType } from "../generated/Api";

export type ActiveEmail = Pick<
  Required<IEmailIRoute>,
  | "subject"
  | "body"
  | "labels"
  | "isFavorite"
  | "toList"
  | "footerId"
  | "aliasId"
  | "type"
  | "showOnArchive"
> & {
  _id: string | undefined;
  tagQuery: IEmailIRoute["tagQuery"];
  scheduleTo: IEmailIRoute["scheduleTo"];
  createdAt?: IEmailIRoute["createdAt"];
  contactsSentTo: IEmailIRoute["contactsSentTo"];
  searchId?: IEmailIRoute["searchId"];
  interestingURLs?: IEmailIRoute["interestingURLs"];
  footer?: IEmailIRoute["footer"];
  alias?: IEmailIRoute["alias"];
  isPersonal?: IEmailIRoute["isPersonal"];
  firstRender?: boolean;
};

export type IActiveEmailAtom = ActiveEmail & {
  font: string;
  emailHash?: string;
  fontSize: number;
  fontColor: string;
  backgroundColor: string;
  placeholderColor: string;
  titleColor: string;
  titlePlaceholderColor: string;
  splitSubject?: string;
  splitMode?: "AGE" | "DOMAIN" | "AGE_DOMAIN";
  scheduleTo?: Date;
};

export const ActiveEmailAtom = atom<IActiveEmailAtom>({
  key: "ActiveEmailAtom",
  default: {
    _id: "",
    subject: "",
    splitSubject: "",
    splitMode: undefined,
    body: "",
    labels: [],
    aliasId: "",
    footerId: "",
    type: IEmailType.Sent,
    font: "Arial",
    fontSize: 16,
    isFavorite: false,
    tagQuery: undefined,
    toList: [],
    scheduleTo: undefined,
    createdAt: undefined,
    contactsSentTo: [],

    // Just HUD for now
    fontColor: "#000000",
    backgroundColor: "#FFFFFF",
    placeholderColor: "#ced4da",
    titleColor: "#2f2f2f",
    titlePlaceholderColor: "#757575",
    showOnArchive: true,
  },
});

export const SentToContactEmailAtom = atom<IActiveEmailAtom>({
  key: "SentToContactEmailAtom",
  default: {
    _id: "",
    subject: "",
    splitSubject: "",
    splitMode: undefined,
    body: "",
    labels: [],
    aliasId: "",
    footerId: "",
    type: IEmailType.Sent,
    font: "Arial",
    fontSize: 16,
    isFavorite: false,
    tagQuery: undefined,
    toList: [],
    scheduleTo: undefined,
    createdAt: undefined,
    contactsSentTo: [],

    // Just HUD for now
    fontColor: "#000000",
    backgroundColor: "#FFFFFF",
    placeholderColor: "#ced4da",
    titleColor: "#2f2f2f",
    titlePlaceholderColor: "#757575",
    showOnArchive: true,
  },
});

export function resetActiveEmailRecoilWithouLabel(
  actualAtom: IActiveEmailAtom
): IActiveEmailAtom {
  return {
    ...actualAtom,
    _id: "",
    subject: "",
    body: "",
    splitSubject: "",
    splitMode: undefined,
    type: IEmailType.Sent,
    isFavorite: false,
    scheduleTo: undefined,
    createdAt: undefined,
  };
}

export type IEditEmailAtom = ActiveEmail & {
  font: string;
  emailHash?: string;
  fontSize: number;
  fontColor: string;
  backgroundColor: string;
  placeholderColor: string;
  titleColor: string;
  titlePlaceholderColor: string;
};

export const EditEmailAtom = atom<IActiveEmailAtom>({
  key: "EditEmailAtom",
  default: {
    _id: "",
    subject: "",
    body: "",
    labels: [],
    aliasId: "",
    footerId: "",
    type: IEmailType.Sent,
    font: "Arial",
    fontSize: 16,
    isFavorite: false,
    tagQuery: undefined,
    toList: [],
    scheduleTo: undefined,
    createdAt: undefined,
    contactsSentTo: [],

    // Just HUD for now
    fontColor: "#000000",
    backgroundColor: "#FFFFFF",
    placeholderColor: "#ced4da",
    titleColor: "#2f2f2f",
    titlePlaceholderColor: "#757575",
    showOnArchive: true,
  },
});
